
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

interface BlogImage {
  name: string;
  url: string;
  metadata?: any;
}

export const useBlogImages = () => {
  const [images, setImages] = useState<BlogImage[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        setLoading(true);
        
        // Récupérer la liste des fichiers dans le bucket blog-images
        const { data, error } = await supabase.storage
          .from('blog-images')
          .list('', {
            limit: 100, // Augmenter la limite pour récupérer plus d'images
            offset: 0,
            sortBy: { column: 'created_at', order: 'desc' }
          });

        if (error) {
          throw error;
        }

        if (data) {
          // Générer les URLs publiques pour chaque image
          const imagesWithUrls = data
            .filter(file => file.name !== '.emptyFolderPlaceholder')
            .map(file => {
              const { data: urlData } = supabase.storage
                .from('blog-images')
                .getPublicUrl(file.name);
              
              return {
                name: file.name,
                url: urlData.publicUrl,
                metadata: file.metadata
              };
            });

          setImages(imagesWithUrls);
        }
      } catch (err) {
        console.error('Erreur lors du chargement des images:', err);
        setError(err instanceof Error ? err.message : 'Erreur inconnue');
      } finally {
        setLoading(false);
      }
    };

    fetchImages();
  }, []);

  return { images, loading, error };
};
